import React from "react";
import { useLocation } from "react-router-dom";
import style from "../../css/mainCSS/footer.module.css";

export const FooterPart = (props) => {
  const { title = "", children } = props;
  return (
    <div className={style.part_container}>
      <div className={style.part_title}>{title}</div>
      {children}
    </div>
  );
};

function Footer(props) {
  const location = useLocation();
  const path = location.pathname.split("/")[1];
  const exception_page = [
    "login", "cart", "print", "register", "midtrans", "user_profile",
    "seller_dashboard", "create_store", "reset_password", "ecosystem_login", "offer"
  ];
  const exception_flag = exception_page.includes(path);

  // view
  if (exception_flag) return <></>;
  return (
    <div className={`body_part_container ${style.container}`}>
      <FooterPart title="Bantuan">
        <a href="">{`Cara Pemesanan`}</a>
        <a href="/terms">{`Syarat & Ketentuan`}</a>
        <a href="/privacy">{`Kebijakan Privasi`}</a>
      </FooterPart>
      <FooterPart title="Hubungi Kami">
        <a href="">
          <i className="bi bi-envelope" />
          {`cs@bursakopi.com`}
        </a>
        {/* <a href="">
          <i className="bi bi-telephone-fill" />
          {`(CS) +62 878-7873-2727`}
        </a> */}
        <a href="">
          <i className="bi bi-telephone-fill" />
          {`+62 821-7222-1379`}
        </a>
      </FooterPart>
      <FooterPart title="Ikuti Kami">
        <a href={`https://www.youtube.com/@bursakopi?app=desktop`} target="blank">
          <i className="bi bi-youtube" />
          {`bursakopi`}
        </a>
        <a href={`https://www.instagram.com/bursakopi.id`} target="blank">
          <i className="bi bi-instagram" />
          {`@bursakopi.id`}
        </a>
      </FooterPart>
    </div>
  );
}

export default Footer;
